import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { SatCoreRegister } from '../SatCoreRegistry';
import { useScript } from '../hooks';

const ThirdPartyChatLauncher = observer((_props) => {
  const { thirdPartyManager } = useContext(MobXProviderContext);

  useScript({
    cryptoId: thirdPartyManager.thirdPartyChatLauncherId,
    url: thirdPartyManager.thirdPartyChatLauncherUrl
  });

  return (<></>);
});
export default ThirdPartyChatLauncher;

SatCoreRegister('ThirdPartyChatLauncher', ThirdPartyChatLauncher);
